export const TECHNICAL_SUPPORT_VERBIAGE =
  'Please contact our technical support team at 800.541.8999';
export const SAVED_SUCCESSFULLY = 'Saved Successfully';
export const GENERIC_ERROR_MESSAGE = 'An error has occurred. Please try again.';
export const GENERIC_NO_DATA_FOUND = 'No data found!';



// WEBPACK FOOTER //
// ./src/common/Constants/verbiage.js